var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatrix2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26465 15.5C3.16008 15.5 2.26465 14.6046 2.26465 13.5C2.26465 12.3954 3.16008 11.5 4.26465 11.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2646 15.5C21.3692 15.5 22.2646 14.6046 22.2646 13.5C22.2646 12.3954 21.3692 11.5 20.2646 11.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26465 7V4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2646 7V4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26465 4C7.81693 4 8.26465 3.55228 8.26465 3C8.26465 2.44772 7.81693 2 7.26465 2C6.71236 2 6.26465 2.44772 6.26465 3C6.26465 3.55228 6.71236 4 7.26465 4Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2646 4C17.8169 4 18.2646 3.55228 18.2646 3C18.2646 2.44772 17.8169 2 17.2646 2C16.7124 2 16.2646 2.44772 16.2646 3C16.2646 3.55228 16.7124 4 17.2646 4Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7646 7H10.7646C7.93622 7 6.52201 7 5.64333 7.90898C4.76465 8.81796 4.76465 10.2809 4.76465 13.2069C4.76465 16.1329 4.76465 17.5958 5.64333 18.5048C6.52201 19.4138 7.93622 19.4138 10.7646 19.4138H11.7899C12.5815 19.4138 12.8608 19.5773 13.4063 20.1713C14.0096 20.8283 14.9437 21.705 15.7888 21.9091C16.99 22.1994 17.1245 21.7979 16.8565 20.6531C16.7802 20.327 16.5898 19.8056 16.7906 19.5018C16.9031 19.3316 17.0905 19.2898 17.4654 19.2061C18.0568 19.074 18.5444 18.8581 18.8859 18.5048C19.7646 17.5958 19.7646 16.1329 19.7646 13.2069C19.7646 10.2809 19.7646 8.81796 18.8859 7.90898C18.0072 7 16.593 7 13.7646 7Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76465 15C10.3347 15.6072 11.2423 16 12.2646 16C13.2869 16 14.1945 15.6072 14.7646 15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27361 11H9.26465",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2736 11H15.2646",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix2);
export default __webpack_public_path__ + "static/media/matrix-2.9e07dc3ed5dbb85fe4737ca2779463e8.svg";
export { ForwardRef as ReactComponent };